function GoogleLogo({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5382 11.2007C19.5382 10.6087 19.4902 10.0135 19.3878 9.43115H11.1738V12.7846H15.8776C15.6824 13.8661 15.0552 14.8229 14.1369 15.4308V17.6067H16.9431C18.591 16.09 19.5382 13.8501 19.5382 11.2007Z"
        fill="#4285F4"
      />
      <path
        d="M11.1746 19.7089C13.5232 19.7089 15.5039 18.9378 16.9471 17.6066L14.1408 15.4308C13.36 15.9619 12.3521 16.2627 11.1778 16.2627C8.90588 16.2627 6.97959 14.73 6.28842 12.6693H3.39258V14.9124C4.8709 17.853 7.88194 19.7089 11.1746 19.7089Z"
        fill="#34A853"
      />
      <path
        d="M6.28482 12.6693C5.92004 11.5878 5.92004 10.4167 6.28482 9.33512V7.09204H3.39217C2.15704 9.55271 2.15704 12.4518 3.39217 14.9124L6.28482 12.6693Z"
        fill="#FBBC04"
      />
      <path
        d="M11.1746 5.73843C12.4161 5.71923 13.616 6.1864 14.5152 7.04396L17.0014 4.55769C15.4271 3.07937 13.3376 2.26661 11.1746 2.29221C7.88194 2.29221 4.8709 4.14811 3.39258 7.09196L6.28522 9.33504C6.97319 7.27115 8.90268 5.73843 11.1746 5.73843Z"
        fill="#EA4335"
      />
    </svg>
  );
}

export default GoogleLogo;
